import React from 'react'
import styled from 'styled-components'
import { withBaseServerSideProps } from '@/HOC/withBaseServerSideProps'
import ValentineHeader from '@/components/molecules/valentine/header'
import { LandingPage, LandingPageType } from '@/network/graphql.g'
import { requestThrow401 } from '@/utils/graphQl'
import { getMainData } from '@/utils/mainDataHelper'
import { Box } from '@/components/atoms/Grid'
import ValentineCategoriesContainer from '@/components/molecules/valentine/categoriesContainer'

type ValentineProps = {
  landingPage: LandingPage
}

const Valentine: React.FC<ValentineProps> = ({ landingPage }) => {
  const valentineCategories = landingPage.sections.map((category) => category)

  return (
    <>
      <ValentineHeader landingPage={landingPage} />
      <MainWrapper>
        {valentineCategories.map((category) => (
          <ValentineCategoriesContainer
            key={category.name}
            category={category}
          />
        ))}
      </MainWrapper>
    </>
  )
}

export default Valentine

export const getServerSideProps = withBaseServerSideProps(
  async ({
    sdk,
    withMainNavigation,
    withStore
  }): Promise<GetServerSideProps<ValentineProps>> => {
    const { success, response } = await requestThrow401({
      method: sdk.getBlackFridayLandingPage,
      variables: {
        type: LandingPageType.Valentine,
        withMainNavigation,
        withStore
      },
      mainResponse: (response) => response?.landingPage
    })
    if (!success) {
      return {
        notFound: true
      }
    }

    return {
      props: {
        mainData: getMainData(response),
        landingPage: response?.landingPage,
        seoTags: response?.seoTags
      }
    }
  }
)

const MainWrapper = styled(Box)`
  width: 100%;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.onBackground};
`
